import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (event: any) => void;
  value?: any;
  name?: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  data: any;
}

interface StyledInputProps {
  helperText: string;
}

const MultiselectDropdown = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  required,
  helperText,
  disabled,
  data,
}: Props) => {
  const [dropdown, setShowDropdown] = useState(false);

  const getLabel = (value: any, data: any) => {
    let filteredLabel = [];
    let filtered = data.filter(function (e: any) {
      // @ts-ignore
      return this.indexOf(e.value) >= 0;
    }, value);
    filteredLabel = filtered.map((item: any) => item.label);
    return filteredLabel.join(",");
  };

  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowDropdown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef);

  return (
    <>
      <InputFieldWrapper ref={wrapperRef}>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputField
          disabled={disabled}
          placeholder={placeholder}
          value={getLabel(value, data)}
          name={name}
          helperText={helperText}
          autoComplete="off"
          onClick={() => setShowDropdown(true)}
        />
        {helperText && <Error>{helperText}</Error>}
        {dropdown && (
          <DropdownList>
            <ul>
              <li>
                <span>{label}</span>
              </li>
              {data.map((item: any) => (
                <li>
                  {item.value && (
                    <>
                      <button
                        onClick={() => onChange({ target:{value: item.value, name} })}
                      >
                        {!value.includes(item.value) ? (
                          <img
                            src={require("../../assets/images/non-checked.png")}
                            alt="fill"
                          />
                        ) : (
                          <img
                            src={require("../../assets/images/checked.png")}
                            alt="fill"
                          />
                        )}
                      </button>
                    </>
                  )}
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
          </DropdownList>
        )}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const DropdownList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 4.5rem;
  width: 99.5%;
  background: white;
  border: 1px solid ${Colors.athensGrey};
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  max-height:15rem;
  overflow-y:auto;
  > ul {
    padding: 0;
    margin: 0.5rem 0;
    list-style-type: none;
    padding-left: 1rem;
    li {
      padding: 0.25rem 0;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      button {
        margin-right: 0.5rem;
        padding: 0;
        border: 0;
        background: transparent;
      }
    }
  }
`;

const InputField = styled.input<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default MultiselectDropdown;
